import React, { useState } from 'react';
import { H4 } from "../../styles/typography/typography.js";
import Popup from '../../components/Popup/Popup.jsx';
import {
  AdditionalContainerStyled,
  VideoWrapStyled,
  VideoPreviewStlyed,
  VideoPlayStlyed,
  VideoTextStlyed,
} from '../Tabs-additional/style.js';

import {
  PopupFrameStyled
} from '../Popup/style.js';

const VideoGallery = ({ trailerBlock }) => {
  const [popupIsOpen, setPopupIsOpen] = useState(false);
  const [fotosIndex, setFotosIndex] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [trailer, setTrailer] = useState(false);

  const handleClick = (id, statusTreiler) => {
    setPopupIsOpen((prev) => !prev);
    setFotosIndex(id);
    setTrailer(statusTreiler);
  };

  const handleClickPlus = () => {
    setFotosIndex((prev) => prev + 1);
  };

  const handleClickMinus = () => {
    setFotosIndex((prev) => prev - 1);
  };

  return (
    <>
      {trailerBlock.length > 0 &&
        <>
          <H4 color="black_text">Тестовове видео для верстки</H4><br />
          <AdditionalContainerStyled>
            {trailerBlock.map((item, index) =>
              <VideoWrapStyled key={index}>
                <VideoPreviewStlyed src={item.preview_ru} width="300" height="168" />
                <VideoPlayStlyed width="60" height="60" viewBox="0 0 80 79" fill="none" onClick={() => handleClick(index, true)}>
                  <g opacity="0.6"><circle cx="40.2303" cy="39.2323" r="32.6932" fill="white" /></g>
                  <path d="M51.6728 40.0491L35.3262 50.6744L35.3262 29.4238L51.6728 40.0491Z" />
                </VideoPlayStlyed>
                <VideoTextStlyed>
                  {item.title} | {item.duration_text}
                </VideoTextStlyed>
              </VideoWrapStyled>
            )}
          </AdditionalContainerStyled>
        </>
      }

      {
        popupIsOpen
          ? <Popup
            arrows={true}
            handleClickMinus={handleClickMinus}
            handleClick={handleClick}
            handleClickPlus={handleClickPlus}
            fotosAll={trailerBlock.length}
            fotosIndex={fotosIndex}>
            {/* key пересоздаёт iframe вместо смены src, чтобы не добавлять запись в историю браузера */}
            <PopupFrameStyled key={trailerBlock[fotosIndex].embed_url} src={trailerBlock[fotosIndex].embed_url} />
          </Popup>
          : null
      }
    </>
  );
};

export default VideoGallery;
